define('views/components/reseller_role/reseller_role_list',['require','views/base/list_view','views/components/reseller_role/reseller_role','text!templates/components/reseller_role/reseller_role_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/reseller_role/reseller_role');

    var temp = require("text!templates/components/reseller_role/reseller_role_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

